import { Fragment } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import styles from './SummaryBanner.css'

const SummaryBanner = props => {
  const {
    summaries,
    inline,
    title,
    className
  } = props
  return (
    <div
      className={clx(
        styles.block,
        { [styles.inline]: inline },
        { [styles.withTitle]: title },
        { [className]: className }
      )}
    >
      {
        !_.isEmpty(title) &&
          <p className={styles.title}>{title}</p>
      }
      {
        summaries.map(({ label, value }, index) => {
          return (
            <Fragment key={index}>
              <span
                key={`label_${index}`}
                className={styles.itemLabel}
              >
                {label}
              </span>
              <span
                key={`value_${index}`}
                className={styles.itemValue}
              >
                {value}
              </span>
            </Fragment>
          )
        })
      }
    </div>
  )
}

export default SummaryBanner
